export default {
  lblEmail: 'LBL_EMAIL_ADDRESS',
  lblPassword: 'LBL_PASSWORD',
  lblEmailPlaceholder: 'LBL_EMAIL_PLACEHOLDER',
  lblPasswordPlaceholder: 'LBL_PASSWORD_PLACEHOLDER',
  lblConfirm: 'LBL_CONFIRM',
  lblUpdatePassword: 'LBL_UPDATE_PASSWORD',
  lblNewPassword: 'LBL_NEW_PASSWORD',
  lblConfirmPassword: 'LBL_CONFIRM_PASSWORD',
  lblForgotPassword: 'LBL_FORGOT_PASSWORD',
  lblSubmit: 'LBL_SUBMIT',
  lblNewPasswordPlaceholder: 'LBL_NEWPASSWORD_PLACEHOLDER',
  lblNewConfirmPasswordPlaceholder: 'LBL_NEWCONFIRMPASSWORD_PLACEHOLDER',
  lblPasswordComparison: 'LBL_PASSWORD_COMPARISON',
  lblMessage: 'LBL_MESSSAGE',
  lblConfirmButton: 'LBL_CONFIRM_BUTTON'
}



// WEBPACK FOOTER //
// ./src/locales/login-form/index.ts